import http from "@/helper/http";
import api from "@/helper/api";

export default {
  state: {
    products: [],
    loadingProducts: false,
    loadingAddProduct: false,
    loadingEditProduct: false,
    loadingDeleteProduct: false,
    loadingCopyCatalogToStores: false,
  },
  mutations: {
    SET_PRODUCTS(state, products) {
      state.products = products;
    },
    SET_LOADING_PRODUCTS(state, loadingProducts) {
      state.loadingProducts = loadingProducts;
    },
    SET_LOADING_ADD_PRODUCT(state, loadingAddProduct) {
      state.loadingAddProduct = loadingAddProduct;
    },
    SET_LOADING_EDIT_PRODUCT(state, loadingEditProduct) {
      state.loadingEditProduct = loadingEditProduct;
    },
    SET_LOADING_DELETE_PRODUCT(state, loadingDeleteProduct) {
      state.loadingDeleteProduct = loadingDeleteProduct;
    },
    SET_LOADING_COPY_CATALOG_TO_STORES(state, loadingCopyCatalogToStores) {
      state.loadingCopyCatalogToStores = loadingCopyCatalogToStores;
    },
  },
  actions: {
    getProducts({ commit }, { storeId, page = 1, per_page = 10, query = "" }) {
      commit("SET_LOADING_PRODUCTS", true);
      return new Promise((resolve, reject) => {
        // TODO: add query params for pagination: page, per_page and search
        http
          .get(
            `${api.get_all_products}/${storeId}?page=${page}&per_page=${per_page}&query=${query}`
          )
          .then((response) => {
            commit("SET_PRODUCTS", response.data);
            commit("SET_LOADING_PRODUCTS", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_PRODUCTS", false);
            reject(error);
          });
      });
    },
    // add and edit product
    addProduct({ commit }, { product }) {
      commit("SET_LOADING_ADD_PRODUCT", true);
      return new Promise((resolve, reject) => {
        http
          .post(`${api.store_product}`, product)
          .then((response) => {
            commit("SET_LOADING_ADD_PRODUCT", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_ADD_PRODUCT", false);
            reject(error);
          });
      });
    },
    editProduct({ commit }, { product }) {
      commit("SET_LOADING_EDIT_PRODUCT", true);
      return new Promise((resolve, reject) => {
        http
          .patch(`${api.store_product}`, product)
          .then((response) => {
            commit("SET_LOADING_EDIT_PRODUCT", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_EDIT_PRODUCT", false);
            reject(error);
          });
      });
    },
    deleteProduct({ commit }, { product_id }) {
      commit("SET_LOADING_DELETE_PRODUCT", true);
      return new Promise((resolve, reject) => {
        http
          .delete(`${api.store_product}`, { data: { product_id } })
          .then((response) => {
            commit("SET_LOADING_DELETE_PRODUCT", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_LOADING_DELETE_PRODUCT", false);
            reject(error);
          });
      });
    },
    copyCatalogToStores({ commit }, payload) {
      commit("SET_LOADING_COPY_CATALOG_TO_STORES", true);
      return new Promise((resolve, reject) => {
        http
          .post(`${api.copy_catalog_to_stores}`, payload)
          .then((response) => {
            commit("SET_LOADING_COPY_CATALOG_TO_STORES", false);
            resolve(response);
          })
          .catch((error) => {
            commit("SET_LOADING_COPY_CATALOG_TO_STORES", false);
            reject(error);
          });
      });
    },
  },
  getters: {
    products: (state) => state.products,
    loadingProducts: (state) => state.loadingProducts,
    loadingAddProduct: (state) => state.loadingAddProduct,
    loadingEditProduct: (state) => state.loadingEditProduct,
    loadingDeleteProduct: (state) => state.loadingDeleteProduct,
    loadingCopyCatalogToStores: (state) => state.loadingCopyCatalogToStores,
  },
};
